export default __webpack_public_path__ + "static/Lato-Light-4b714fc19cef4b0adea0510b052b1b98.woff";